import { useTranslation } from "react-i18next";
import Status from "@ingka/status";
import { REGISTERED, WAITING_LIST } from "../../containers/Register/enums";
import {
  isUserRegisteredToEvent,
  useAppContext,
} from "../../contextProviders/AppContext";
import { CSSEvent, TimeSlot } from "../../types/model";
import { isTimeSlotFullyBooked } from "../../utils";

const FULLY_BOOKED = "FULLY_BOOKED";
const FEW_SPOTS_LEFT = "FEW_SPOTS_LEFT";
const REGISTER_NOW = "REGISTER_NOW";
const JOIN_WAITING_LIST = "JOIN_WAITING_LIST";

type PropsType = {
  event: CSSEvent;
};

const statuses = {
  [FULLY_BOOKED]: {
    label: "event.fullyBooked",
  },
  [FEW_SPOTS_LEFT]: {
    label: "event.fewSpotsLeft",
  },
  [REGISTER_NOW]: {
    label: "event.registerNow",
  },
  [JOIN_WAITING_LIST]: {
    label: "register.joinOnWaitingList",
  },
};

function getCurrentCount(timeSlots: TimeSlot[] = []) {
  return timeSlots.reduce((acc, timeSlot: TimeSlot) => {
    return acc + timeSlot.currentRegistrationCount;
  }, 0);
}

function getMaxCount(timeSlots: TimeSlot[] = []) {
  return timeSlots.reduce((acc, timeSlot: TimeSlot) => {
    let maxCount = timeSlot.registrationSettings.maxRegistrationCount;
    if (maxCount === 0) {
      maxCount = Number.MAX_SAFE_INTEGER;
    }
    return acc + maxCount;
  }, 0);
}

const RegistrationStatus = ({ event }: PropsType) => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const [isUserRegistered, registrationState] = useSelector(
    isUserRegisteredToEvent(event)
  );
  const LIMIT = 0.75;
  let status = statuses[REGISTER_NOW];
  const current = getCurrentCount(event.timeSlots);
  const max = getMaxCount(event.timeSlots);
  const registrationRequired =
    event?.registrationSettings?.registrationRequired;

  const isFullyBooked = event.timeSlots.every(isTimeSlotFullyBooked);

  if (!registrationRequired) {
    return <p>{t("event.noRegistrationRequired")}</p>;
  }

  if (isUserRegistered) {
    const copy: { [k: string]: string } = {
      [REGISTERED]: "event.registered",
      [WAITING_LIST]: "event.onWaitingList",
    };

    return <Status label={t(copy[registrationState])} statusColor="green" />;
  }

  if (isFullyBooked) {
    status = statuses[FULLY_BOOKED];
  } else if (current === max) {
    status = statuses[JOIN_WAITING_LIST];
  } else if (current / max > LIMIT) {
    status = statuses[FEW_SPOTS_LEFT];
  }

  return <p>{t(status.label)}</p>;
};

export default RegistrationStatus;
